import { cities } from '../constants/cities';
import { IAddressRedux } from '../typings/CustomTypes/IAddressRedux';

export const formatAddress = (address?: IAddressRedux | any) => {
  if (!address) return '';
  const cityNumber = cities.find((city) => city.value === address.city);
  const zip = address.zipCode ? `${address.zipCode}` : '';
  const city = cityNumber ? cityNumber.label : address.city || '';
  return ` ${address.street} ${address.buildNumber}, ${city ? `${city}` : ''} ${zip}`;
};

export const getConvertDataToFetch = (data: IAddressRedux) => {
  const district = '';
  const addressDictionaryId = data.buildObj ? data.buildObj.value : null;
  const buildNumber: string = data.buildObj ? data.buildObj.extra.build : data.buildNumber.trim();
  const cityNumber = cities.find((city) => city.value === data.city || city.label === data.city);
  return {
    district,
    city: cityNumber ? cityNumber.label : String(data.city).trim(),
    street: data.street.trim(),
    buildNumber,
    addressDictionary: {
      id: addressDictionaryId,
    },
    notes: null,
    corps: null,
    zipCode: data.zipCode,
  } as any;
};
